import {
    computed,
    inject,
    Injectable,
    Renderer2,
    RendererFactory2,
    signal,
    WritableSignal
} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeModeService {
    private readonly rendererFactory = inject(RendererFactory2);
    private renderer: Renderer2;
    private _isDarkTheme: WritableSignal<boolean> = signal(false);

    public isDarkTheme = computed(() => this._isDarkTheme());

    constructor(
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
        this.renderer.addClass(document.body, 'mat-app-background');
    }

    switchTheme(theme: string) {
        if (theme === 'dark') {
            this.renderer.addClass(document.body, 'dark-theme');
            this._isDarkTheme.set(true);
        } else {
            this.renderer.removeClass(document.body, 'dark-theme');
            this._isDarkTheme.set(false);
        }
    }
}
